import { Injectable } from "@nestjs/common";
import { InjectDataSource, InjectRepository } from "@nestjs/typeorm";
import { Not, DataSource } from "typeorm";
import { M3TrimsEntity } from "./m3-trims.entity";
import { M3TrimsAdapter } from "./m3-trims.adaptor";
import { M3TrimsRepo } from "./m3-trims.repository";
import {  BuyerRefNoRequest, CommonResponseModel, ItemTypeEnum, M3TrimFilterReq, M3TrimType, M3TrimTypeRequest, M3trimsDTO, UploadResponse, m3ItemIdreq } from "@project-management-system/shared-models";
import { M3TrimsDTO } from "./m3-trims.dto";
import * as nodemailer from 'nodemailer';

@Injectable()
export class M3TrimsService {
  private transporter: nodemailer.Transporter;
  constructor(
    private adapter: M3TrimsAdapter,
    @InjectRepository(M3TrimsEntity)
    private repository: M3TrimsRepo,
    @InjectDataSource()
    private datasource: DataSource
  ) { 
          this.transporter = nodemailer.createTransport({
                                  service: 'gmail',
                                  auth: {
                                    user: 'helpdesk@schemaxtech.com',
                                    pass: 'jend gpnz htps asjn',  
                                  },
                              });
      }

  async createM3Trims(createDto: M3TrimsDTO): Promise<CommonResponseModel> {
    try {
      const existingItemCount = await this.repository.find({relations:["buyerInfo"],where:{trimType : Not (ItemTypeEnum.FABRIC), buyerInfo:{buyerId:createDto.buyerId}}});
      // console.log("existingItemCount");
      // console.log(existingItemCount);
      // console.log(existingItemCount.length);

      const maxCode = existingItemCount
      .map((item) => {
        const match = item.itemCode.match(/TRIM(\d+)/); // Extract numeric part after 'TRIM'
        return match ? parseInt(match[1], 10) : 0;
      })
      .reduce((max, num) => Math.max(max, num), 0);

        // const nextItemCode: string = createDto.buyerCode + "/" + `TRIM${(existingItemCount.length + 1).toString().padStart(5, '0')}`;
        // createDto.itemCode = nextItemCode;
        const nextItemCode: string = `${createDto.buyerCode}/TRIM${(maxCode + 1).toString().padStart(5, "0")}`;
        createDto.itemCode = nextItemCode;
        // console.log(createDto);
      const entity: M3TrimsEntity = this.adapter.convertDtoToEntity(createDto);
      const count: M3TrimsEntity = await this.repository.save(entity);
      const saveDto: M3TrimsDTO = this.adapter.convertEntityToDto(count);
      // return new CommonResponseModel(false, 0, "")

        
         try{
          // const sendmail = await this.transporter.sendMail(sendOptions)
          return new CommonResponseModel(true, 1, 'purchased Order Created Sucessfully',saveDto)
        }catch(error){

            return new CommonResponseModel(false, 0, 'Something went Wrong')
        }
    } catch (error) {
      return new CommonResponseModel(false, 0, error)
    }
  }

  
  async getM3Trims(): Promise<CommonResponseModel> {
    let query = `SELECT m3.m3_trim_Id as m3TrimsId,m3.trim_code AS trimCode,m3.trim_type AS trimType from m3_trims m3
        `
    const data = await this.datasource.query(query)
    if (data)
      return new CommonResponseModel(true, 65441, "Data Retrieved Successfully", data)
    else
      return new CommonResponseModel(false, 0, 'No data found')
  }

  async getM3TrimsByBuyer(req: M3TrimFilterReq): Promise<CommonResponseModel> {
    try{
      // console.log(req,'#############################')
      
      let query = `Select m3.item_code AS itemCode,m3.m3_trim_Id as m3TrimsId,m3.trim_code AS trimCode,m3.trim_type AS trimType, uom_id AS uomId, u.uom AS uom, c.colour_id AS colorId, c.colour AS colorName from m3_trims m3 left join uom u on u.id = m3.uom_id left join colour c on c.colour_id = m3.color_id where m3.m3_trim_Id>0`
      if (req.buyerId != undefined) {
        query = query + ` AND m3.buyer_id=${req.buyerId}`
      }
      if (req.trimCategory != undefined) {
        query = query + ` AND m3.trim_category_id=${req.trimCategory}`
      }
      if (req.trimType != undefined) {
        query = query + ` AND m3.trim_type="${req.trimType}"`
      }
      if (req.trimMapId != undefined) {
        query = query + ` AND m3.trim_mapping_id=${req.trimMapId}`
      }
      if(req.categoryId != undefined){
        query = query+' and m3.category_id='+req.categoryId+''
      }
      if(req.contentId != undefined){
        query = query+' and m3.content_id='+req.contentId+''
      }
      if(req.finishId != undefined){
        query=query+' and m3.finish_id='+req.finishId+''
      }
      if(req.holeId != undefined){
        query=query+' and m3.hole_id='+req.holeId+''
      }
      if(req.hsnCode != undefined){
        query=query+' and m3.hsn_code="'+req.hsnCode+'"'
      }
      if(req.typeId != undefined){
        query=query+' and m3.type_id='+req.typeId+''
      }
      if(req.m3Code != undefined){
        query=query+' and m3.m3_code="'+req.m3Code+'"'
      }
      query = query + ` group by m3.m3_trim_Id`
      const data = await this.datasource.query(query);
      // console.log(data);
      // console.log(data.length);

      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }
      else{
        return new CommonResponseModel(false, 1010, "No data found",)
      }
    }catch (error) {
      return new CommonResponseModel(false, 0, error)
    }
  }

  async getM3TrimsByTrimCode(req: M3TrimTypeRequest): Promise<CommonResponseModel> {
    try{
      const query = "Select m3.m3_trim_Id as m3TrimsId,m3.trim_code AS trimCode,m3.trim_type AS trimType from m3_trims m3 where trim_type = '"+req.trimType + "'";
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }
    }catch (error) {
      return new CommonResponseModel(false, 0, error)
    }
  }

  async getAllM3Data(req:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      // console.log('oooooooooooo');
      
      let query = 
      `select m3t.trim_code AS trimCode,m3t.item_code as itemCode,m3t.trim_type as trimType,m3t.logo,m3t.part,
      m3t.buyer_id as buyerId,concat(b.buyer_code,'-',b.buyer_name) as buyerName,
      m3t.category_id as categoryId,cg.category,
      m3t.color_id as colorId,c.colour,
      m3t.content_id as contentId,ct.content,
      m3t.finish_id as finishId,f.finish,
      m3t.hole_id as holeId,h.hole,
      m3t.quality_id as qualityId,q.quality_name as qualityName,
      m3t.structure_id as structureId,s.structure,
      m3t.thickness_id as thicknessId,t.thickness,
      m3t.type_id as typeId,ty.type,
      m3t.uom_id as uomId,
      u.uom,
      m3t.variety_id as varietyId,v.variety,
      m3t.trim_category_id as trimCategoryId,tr.trim_category as trimCategory,
      m3t.trim_buyer_id AS trimBuyerId,tb.trim_buyer AS trimBuyer,
      m3t.length_id AS lengthId,l.length,
      m3t.line_id AS lineId,line.line,
      m3t.parts_id AS partsId,p.parts,
      m3t.ply_id AS plyId,ply.ply,
      m3t.shape_id AS shapeId,sh.shape,
      m3t.slider_id AS sliderId,sl.slider,
      m3t.trim_size_id AS trimSizeId,ts.trim_size AS trimSize,
      m3t.trim_mapping_id as trimMappingId,
      m3t.m3_code as m3Code,
      m3t.hsn_code as hsnCode, m3t.file_name AS fileName,
      pl.plant_name as plantName
      from m3_trims m3t
      left join buyers b on b.buyer_id = m3t.buyer_id
      left join category cg on cg.category_id = m3t.category_id
      left join colour c on c.colour_id = m3t.color_id
      left join content ct on ct.content_id = m3t.content_id
      left join finish f on f.finish_id = m3t.finish_id
      left join hole h on h.hole_id = m3t.hole_id
      left join qualitys q on q.quality_id = m3t.quality_id
      left join structure s on s.structure_id = m3t.structure_id
      left join thickness t on t.thickness_id = m3t.thickness_id
      left join type ty on ty.type_id = m3t.type_id
      left join trim_uom u on u.uom_id = m3t.uom_id
      left join variety v on v.variety_id = m3t.variety_id
      left join trim tr on tr.trim_id = m3t.trim_category_id
      left join trim_params_mapping tpm on tpm.trim_mapping_id = m3t.trim_mapping_id
      LEFT JOIN trim_buyer tb ON tb.trim_buyer_id = m3t.trim_buyer_id
      LEFT JOIN length l ON l.length_id = m3t.length_id
      LEFT JOIN line line ON line.line_id = m3t.line_id
      LEFT JOIN parts p ON p.parts_id = m3t.parts_id
      LEFT JOIN ply ply ON ply.ply_id = m3t.ply_id
      LEFT JOIN shape sh ON sh.shape_id = m3t.shape_id
      LEFT JOIN slider sl ON sl.slider_id = m3t.slider_id
      LEFT JOIN trim_size ts ON ts.trim_size_id = m3t.trim_size_id
      left join plants pl ON pl.plant_id=m3t.plant_id
      WHERE 1=1`
      if (req?.buyerId) {
        query = query + ` AND m3t.buyer_id=${req.buyerId}`
      }
      if (req?.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      if (req?.trimType) {
        query = query + ` AND m3t.trim_type="${req.trimType}"`
      }
      if (req?.structureId) {
        query = query + ` AND m3t.structure_id=${req.structureId}`
      }
      if (req?.categoryId) {
        query = query + ` AND m3t.category_id=${req.categoryId}`
      }
      if (req?.contentId) {
        query = query + ` AND m3t.content_id=${req.contentId}`
      }
      if (req?.typeId) {
        query = query + ` AND m3t.type_id=${req.typeId}`
      }
      if (req?.finishId) {
        query = query + ` AND m3t.finish_id=${req.finishId}`
      }
      if (req?.holeId) {
        query = query + ` AND m3t.hole_id=${req.holeId}`
      }
      if (req?.qualityId) {
        query = query + ` AND m3t.quality_id=${req.qualityId}`
      }
      if (req?.thicknessId) {
        query = query + ` AND m3t.thickness_id=${req.thicknessId}`
      }
      if (req?.varietyId) {
        query = query + ` AND m3t.variety_id=${req.varietyId}`
      }
      if (req?.uomId) {
        query = query + ` AND m3t.uom_id=${req.uomId}`
      }
      if (req?.colorId) {
        query = query + ` AND m3t.color_id=${req.colorId}`
      }
      if (req?.logo) {
        query = query + ` AND m3t.logo='${req.logo}'`
      }
      if (req?.part) {
        query = query + ` AND m3t.part='${req.part}'`
      }
      if (req?.trimBuyerId) {
        query = query + ` AND m3t.trim_buyer_id=${req.trimBuyerId}`
      }
      if (req?.lengthId) {
        query = query + ` AND m3t.length_id=${req.lengthId}`
      }
      if (req?.lineId) {
        query = query + ` AND m3t.line_id=${req.lineId}`
      }
      if (req?.partsId) {
        query = query + ` AND m3t.parts_id=${req.partsId}`
      }
      if (req?.plyId) {
        query = query + ` AND m3t.ply_id=${req.plyId}`
      }
      if (req?.shapeId) {
        query = query + ` AND m3t.shape_id=${req.shapeId}`
      }
      if (req?.sliderId) {
        query = query + ` AND m3t.slider_id='${req.sliderId}'`
      }
      if (req?.trimSizeId) {
        query = query + ` AND m3t.trim_size_id='${req.trimSizeId}'`
      }
      query = query + ` order by b.short_code, m3t.item_code ASC`

      const data = await this.datasource.query(query)
      // console.log(data,'pppppppppppp');
      
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllTypes(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.type_id AS typeId, t.type, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN type t ON t.type_id = m3t.type_id
      WHERE t.type is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.type_id ORDER BY t.type `
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllContents(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.content_id AS contentId, c.content, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN content c ON c.content_id = m3t.content_id
      WHERE c.content is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.content_id ORDER BY c.content`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllFinishes(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.finish_id AS finishId, f.finish,f.finish_code as finishCode, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN finish f ON f.finish_id = m3t.finish_id
      WHERE f.finish is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.finish_id ORDER BY f.finish`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllHoles(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.hole_id AS holeId, h.hole, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN hole h ON h.hole_id = m3t.hole_id
      WHERE h.hole is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.hole_id ORDER BY h.hole`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllStructures(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.structure_id AS structureId, s.structure, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN structure s ON s.structure_id = m3t.structure_id
      WHERE s.structure is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.structure_id ORDER BY s.structure`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllCategories(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.category_id AS categoryId, c.category, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN category c ON c.category_id = m3t.category_id
      WHERE c.category is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.category_id ORDER BY c.category`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllQuality(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.quality_id AS qualityId, q.quality_name as qualityName, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN qualitys q ON q.quality_id = m3t.quality_id
      WHERE q.quality_name is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.quality_id ORDER BY q.quality_name`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllThickness(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.thickness_id AS thicknessId, t.thickness, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN thickness t ON t.thickness_id = m3t.thickness_id
      WHERE t.thickness is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.thickness_id ORDER BY t.thickness`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllVariety(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.variety_id AS varietyId, v.variety, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN variety v ON v.variety_id = m3t.variety_id
      WHERE v.variety is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.variety_id ORDER BY v.variety`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllUom(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.uom_id AS uomId, u.uom, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN uom u ON u.id = m3t.uom_id
      WHERE u.uom is not null`
      if (req.trimMappingId) {
        query = query + ` AND m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.uom_id ORDER BY u.uom`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }
  
  async getAllColors(req?:M3trimsDTO):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.color_id AS uomId, c.colour as color, m3t.trim_mapping_id
      FROM m3_trims m3t
      LEFT JOIN colour c ON c.colour_id = m3t.color_id
      WHERE c.colour is not null`
      if (req.trimMappingId) {
        query = query + ` WHERE m3t.trim_mapping_id=${req.trimMappingId}`
      }
      query = query + ` GROUP BY m3t.color_id ORDER BY c.colour`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllTrimCategories(req?:M3TrimType):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.trim_category_id AS trimCategoryId, t.trim_category AS trimCategory,m3t.trim_mapping_id AS trimMappingId
      FROM m3_trims AS m3t
      LEFT JOIN trim t ON t.trim_id = m3t.trim_category_id
      WHERE t.trim_category is not null`
      if (req.trimType) {
        query = query + ` AND m3t.trim_type='${req.trimType}'`
      }
      if (req.buyerId) {
        query = query + ` and m3t.buyer_id=${req.buyerId}`
      }
      query = query + ` GROUP BY t.trim_id
      ORDER BY t.trim_category`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async getAllBuyers(req?:BuyerRefNoRequest):Promise<CommonResponseModel>{
    try{
      let query = 
      `SELECT m3t.buyer_id AS buyerId, b.buyer_name AS buyerName, b.buyer_code AS buyerCode
      FROM m3_trims m3t
      LEFT JOIN buyers b ON b.buyer_id = m3t.buyer_id
      WHERE b.buyer_name is not null`
      if (req.buyerRefNo!=null && req.buyerRefNo!='admin') {
        query = query + ` AND b.external_ref_number = ${req.buyerRefNo}`
      }
      query = query + ` GROUP BY m3t.buyer_id ORDER BY b.buyer_name`
      const data = await this.datasource.query(query)
      if(data.length > 0){
        return new CommonResponseModel(true, 1001, "Data Retrieved Successfully", data)
      }else {
        return new CommonResponseModel(false, 1, "No data found", [])
    }
    }catch(err){
      throw(err)
    }
  }

  async updateTrimPath(filePath: string, filename: string, m3TrimId: number): Promise<UploadResponse> {
    // console.log('upload service id---------------', m3TrimId)
    try {
        let filePathUpdate;   
            filePathUpdate = await this.repository.update(
                { m3TrimId: m3TrimId },
                { filePath: filePath, fileName: filename },
            )
        if (filePathUpdate.affected > 0) {
            return new UploadResponse(true, 11, 'uploaded successfully', filePath);
        }
        else {
            return new UploadResponse(false, 11, 'uploaded failed', filePath);
        }
    }
    catch (error) {
        console.log(error);
    }
}


async getItemByTrimId(req:m3ItemIdreq): Promise<CommonResponseModel> {
  try {
      let data =  await this.repository.findOne({
              where:{m3TrimId : req.m3ItemId },
        })
      if (data.m3TrimId > 0) {
          return new CommonResponseModel(true, 11, 'Data retrived successfully. ', data);
      }
      else {
          return new CommonResponseModel(false, 11, 'uploaded failed', data);
      }
  }
  catch (error) {
      console.log(error);
  }
}


}